import {Component} from '@angular/core';
import {MatDialogActions, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {BUDGET_SCOPES} from '../models/budget-scopes';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {RouterLink} from '@angular/router';

@Component({
    selector: 'app-budget-scope-dialog',
    templateUrl: './budget-scope-dialog.component.html',
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        MatDialogActions,
        MatButtonModule,
        MatDialogClose,
        RouterLink
    ]
})
export class BudgetScopeDialogComponent {

    budgetScope: string[] = [];

    readonly BUDGET_SCOPES = BUDGET_SCOPES;

    constructor(
        private dialogRef: MatDialogRef<BudgetScopeDialogComponent>
    ) {
    }

    save() {
        this.dialogRef.close(this.budgetScope);
    }
}